import React from "react";
import { CustomButton } from "../../components/customButton/CustomButton";

function ConfirmationModalBody({ onClickYes, onClickNo, loading }) {
  return (
    <div
      style={{
        backgroundColor: "white",
        height: 200,
        width: 400,
        padding: "20px 30px 20px 30px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <p
        style={{
          color: "black",
          fontSize: 14,
          textAlign: "center",
        }}
      >
        Do you want to update the url? OTP will sent to registered email
        address.
      </p>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <CustomButton
          title="Yes"
          textStyles={{
            color: "white",
          }}
          styles={{
            border: "none",
          }}
          onClick={onClickYes}
          loading={loading}
        />
        <CustomButton
          title="No"
          styles={{
            backgroundColor: "white",
            border: "1px solid dodgerblue",
          }}
          textStyles={{
            color: "dodgerblue",
          }}
          onClick={onClickNo}
        />
      </div>
    </div>
  );
}

export default ConfirmationModalBody;
